interface Event {
    id: string;
    title: string;
    isActive: boolean;
  }
  
  export function hasActiveEvent(array: Event[]): boolean {
    return array?.some(item => item?.isActive === true);
  }
  